import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

function shift(month, delta) {
  const [y, m] = month.split("-").map(Number);
  const d = new Date(Date.UTC(y, m - 1 + delta, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}

export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export default function MonthPicker({ value, onChange }) {
  const { i18n } = useTranslation();
  const [y, m] = (value || currentMonth()).split("-").map(Number);
  const label = new Date(Date.UTC(y, m - 1, 1)).toLocaleString(i18n.language, { month: "long", year: "numeric" });
  const isCurrent = value === currentMonth();
  return (
    <div className="pmonth-picker inline-flex items-center gap-0.5" data-testid="month-picker">
      <button
        type="button"
        onClick={() => onChange(shift(value, -1))}
        aria-label="Previous month"
        data-testid="month-prev"
        className="pmonth-arrow"
      >
        <ChevronLeft className="h-4 w-4" strokeWidth={2.4} />
      </button>
      <button
        type="button"
        className="pmonth-label"
        onClick={() => onChange(currentMonth())}
        data-testid="month-label"
        title={isCurrent ? "Current month" : "Jump to current month"}
      >
        {label}
      </button>
      <button
        type="button"
        onClick={() => onChange(shift(value, 1))}
        disabled={isCurrent}
        aria-label="Next month"
        data-testid="month-next"
        className="pmonth-arrow"
      >
        <ChevronRight className="h-4 w-4" strokeWidth={2.4} />
      </button>
    </div>
  );
}
